import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import ActionsMenu from '../../ui/ActionsMenu'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'

const TRIGGER = 'tw:inline-flex tw:items-center tw:justify-center tw:w-[30px] tw:h-[30px] tw:rounded-md!'
  + ' tw:border-0 tw:bg-transparent tw:cursor-pointer tw:text-gray-500 tw:hover:bg-gray-100'
  + ' tw:hover:text-gray-700 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed'
  + ' tw:disabled:hover:bg-transparent'

const ConditionMenu = ({ onDuplicate, onDelete, disabled }) => {
  const [triggerEl, setTriggerEl] = useState(null)
  const [open, setOpen] = useState(false)

  const handleToggle = useCallback(event => {
    setTriggerEl(event.currentTarget)
    setOpen(prev => !prev)
  }, [])
  const handleClose = useCallback(() => setOpen(false), [])

  const items = [
    { label: 'Dupliquer', icon: DuplicateIcon, onClick: onDuplicate },
    { label: 'Supprimer', icon: TrashCanIcon, onClick: onDelete, variant: 'danger' }
  ]

  return (
    <>
      <button
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label="Plus d'actions"
        className={TRIGGER}
        disabled={disabled}
        type="button"
        onClick={handleToggle}
      >
        <i aria-hidden="true" className="fas fa-ellipsis-vertical" />
      </button>
      <ActionsMenu
        anchorEl={triggerEl}
        ariaLabel="Actions sur la condition"
        isOpen={open}
        items={items}
        onClose={handleClose}
      />
    </>
  )
}

ConditionMenu.propTypes = {
  disabled: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired
}

ConditionMenu.defaultProps = {
  disabled: false
}

export default ConditionMenu
